// Consent banner for analytics - Alpine.js component

export const consent = () => ({
  // State
  showBanner: false,
  analyticsEnabled: false,
  
  // Initialize component
  init() {
    console.log('Consent system initialized');
    this.checkConsentStatus();
  },
  
  // Check if consent has been given
  checkConsentStatus() {
    const consent = localStorage.getItem('analytics-consent');
    
    if (consent === null) {
      // No consent decision yet, show banner
      this.showBanner = true;
      this.analyticsEnabled = false;
    } else {
      // Consent decision exists
      this.analyticsEnabled = consent === 'true';
      this.showBanner = false;
      
      // Load analytics if enabled
      if (this.analyticsEnabled) {
        this.loadAnalytics();
      }
    }
  },
  
  // Accept analytics consent
  acceptConsent() {
    localStorage.setItem('analytics-consent', 'true');
    this.analyticsEnabled = true;
    this.showBanner = false;
    
    // Load analytics
    this.loadAnalytics();
    
    // Show confirmation toast
    this.showToast('Analíticas habilitadas. ¡Gracias!', 'success');
    
    console.log('Analytics consent accepted');
  },
  
  // Decline analytics consent
  declineConsent() {
    localStorage.setItem('analytics-consent', 'false');
    this.analyticsEnabled = false;
    this.showBanner = false;
    
    // Show confirmation toast
    this.showToast('Analíticas deshabilitadas. Respetamos tu privacidad.', 'info');
    
    console.log('Analytics consent declined');
  },
  
  // Load analytics scripts dynamically
  async loadAnalytics() {
    if (!this.analyticsEnabled) return;
    
    try {
      // Load Fathom analytics
      const { initFathom } = await import('../analytics/fathom.js');
      await initFathom();
      
      // Load Cloudflare Browser Insights
      this.loadCloudflareInsights();
      
      // Load OneSignal (if needed)
      // const { initOneSignal } = await import('../analytics/onesignal.js');
      // await initOneSignal();
      
      console.log('Analytics loaded successfully');
      
    } catch (error) {
      console.warn('Failed to load analytics:', error);
    }
  },
  
  // Cloudflare Browser Insights COMPLETELY DISABLED
  loadCloudflareInsights() {
    // CF Insights disabled - no script injection, no beacon token usage
    console.log('Cloudflare Insights permanently disabled for null-safety and CORS prevention');
    return;
  },
  
  // Reset consent (for testing)
  resetConsent() {
    localStorage.removeItem('analytics-consent');
    this.checkConsentStatus();
    
    console.log('Consent reset');
  },
  
  // Show toast helper
  showToast(message, type = 'info') {
    window.dispatchEvent(new CustomEvent('show-toast', {
      detail: { message, type, duration: 4000 }
    }));
  }
});